exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.avatar[data-v-47ed99bf]{width:200px;height:262px\n}\n", ""]);

// exports
